import React from 'react';
import useRead from '../../hooks/useRead';
import { useParams } from 'react-router-dom';
import Moment from 'react-moment';
import Pagination from '../../components/pagination';
import RoundedContainer from '../../components/containers/RoundedContainer';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from '../../components/table/Table';

const LeaveEditHistory = () => {
    let { id } = useParams();
    let initialData = {
        id,
        search_query: '',
        limit: 50,
        page_number: 0
    };
    const { list, paramsObject } = useRead({
        url: 'getLeaveEditHistory',
        initialData,
        onSuccess: (res) => {
            console.log(res);
        }
    });
    const handlePageClick = (val) => { };
    return (
        <div className='px-5 pb-20'>
            <RoundedContainer className="mt-8">
                <div className="max-w-full overflow-x-auto">
                    <Table className="table-auto w-full">
                        <TableHead>
                            <TableHeaderCell className="w-[18%]">Reason</TableHeaderCell>
                            <TableHeaderCell className="w-[14%]">Leave Type</TableHeaderCell>
                            <TableHeaderCell className="w-[12%] text-center">From Date</TableHeaderCell>
                            <TableHeaderCell className="w-[12%] text-center">To Date</TableHeaderCell>
                            <TableHeaderCell className="w-[14%] text-center">Edited On</TableHeaderCell>
                            <TableHeaderCell className="w-[14%] text-center">Approved On</TableHeaderCell>
                            <TableHeaderCell className="w-[16%] text-center">Leave Status</TableHeaderCell>
                        </TableHead>
                        <TableBody>
                            {list.data?.data?.map((data, idx) => {
                                return (
                                    <TableRow key={idx}>
                                        <TableCell className="text-dark font-medium text-sm">
                                            {data.reason || '-----'}
                                        </TableCell>
                                        <TableCell className="text-dark font-medium text-sm capitalize">
                                            {data.leave_type}
                                        </TableCell>
                                        <TableCell className='text-center text-dark font-medium text-sm'>
                                            <Moment unix format='DD/MM/YYYY'>{data.from_date}</Moment>
                                        </TableCell>
                                        <TableCell className='text-center text-dark font-medium text-sm'>
                                            <Moment unix format='DD/MM/YYYY'>{data.to_date}</Moment>
                                        </TableCell>
                                        <TableCell className='text-center text-dark font-medium text-sm'>
                                            <Moment unix format='DD/MM/YYYY'>{data.edited_on}</Moment>
                                        </TableCell>
                                        <TableCell className='text-center text-dark font-medium text-sm'>
                                            <Moment unix format='DD/MM/YYYY'>{data.approved_date}</Moment>
                                        </TableCell>
                                        <TableCell className="text-center">
                                            {data.leave_status === '1' ? (
                                                <span className='bg-green-100 text-green-700 font-medium px-2.5 py-1 rounded-full text-xs'>Approved</span>
                                            ) : data.leave_status === '2' ? (
                                                <span className='bg-yellow-100 text-yellow-700 font-medium px-2.5 py-1 rounded-full text-xs'>Pending</span>
                                            ) : (
                                                <span className='bg-red-100 text-red-700 font-medium px-2.5 py-1 rounded-full text-xs'>Rejected</span>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </div>
            </RoundedContainer>
            {list.data?.count > paramsObject?.limit && (
                <RoundedContainer className='mt-4'>
                    <Pagination
                        currentPage={+paramsObject.page_number}
                        lengthofItems={list.data?.count}
                        limit={paramsObject.limit}
                        onPageChange={handlePageClick}
                    />
                </RoundedContainer>
            )}
        </div>
    );
};

export default LeaveEditHistory;